(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[882],{

/***/ 2559:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/other",
      function () {
        return __webpack_require__(3218);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_Contact_ContactView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7596);
/* harmony import */ var constants_paths__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1685);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_DefaultHead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3978);





const OrderForm = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(669), __webpack_require__.e(57)]).then(__webpack_require__.bind(__webpack_require__, 6057)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6057)
            ]
    },
    ssr: false
});
const Other = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Contact_ContactView__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DefaultHead__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "その他 - shizai",
                description: "shizaiはオリジナルパッケージを低コスト・高品質で作れるプラットフォームです。ECで必要なパッケージの見積もりをかんたんに取得できます。",
                url: "shiza1.com" + constants_paths__WEBPACK_IMPORTED_MODULE_2__/* .paths.contactOther */ .Hb.contactOther
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OrderForm, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Other);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [957,774,888,179], function() { return __webpack_exec__(2559); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);